module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/events/events-master/events-master.component.scss
// module id = ./src/app/routes/events/events-master/events-master.component.scss
// module chunks = 9